const FETCH_MATERIAL_CONTROL = "FETCH_MATERIAL_CONTROL";
const FETCH_MATERIAL_CONTROL_SUCCESS = "FETCH_MATERIAL_CONTROL_SUCCESS";
const FETCH_MATERIAL_CONTROL_ERROR = "FETCH_MATERIAL_CONTROL_ERROR";
const FETCH_PROJECT_ACTIVITIES = "FETCH_PROJECT_ACTIVITIES";
const FETCH_PROJECT_ACTIVITIES_SUCCESS = "FETCH_PROJECT_ACTIVITIES_SUCCESS";
const FETCH_PROJECT_ACTIVITIES_ERROR = "FETCH_PROJECT_ACTIVITIES_ERROR";
const FETCH_PROJECT_ACTIVITIES_GRAPH_DATA =
  "FETCH_PROJECT_ACTIVITIES_GRAPH_DATA";
const FETCH_PROJECT_ACTIVITIES_GRAPH_DATA_SUCCESS =
  "FETCH_PROJECT_ACTIVITIES_GRAPH_DATA_SUCCESS";
const FETCH_PROJECT_ACTIVITIES_GRAPH_DATA_ERROR =
  "FETCH_PROJECT_ACTIVITIES_GRAPH_DATA_ERROR";
const UPDATE_PROJECT_ACTIVITY = "UPDATE_PROJECT_ACTIVITY";
const UPDATE_PROJECT_ACTIVITY_SUCCESS = "UPDATE_PROJECT_ACTIVITY_SUCCESS";
const UPDATE_PROJECT_ACTIVITY_ERROR = "UPDATE_PROJECT_ACTIVITY_ERROR";
const FETCH_PROJECT_ACTIVITIES_SEARCH_DATA =
  "FETCH_PROJECT_ACTIVITIES_SEARCH_DATA";
const FETCH_PROJECT_ACTIVITIES_SEARCH_DATA_SUCCESS =
  "FETCH_PROJECT_ACTIVITIES_SEARCH_DATA_SUCCESS";
const FETCH_PROJECT_ACTIVITIES_SEARCH_DATA_ERROR =
  "FETCH_PROJECT_ACTIVITIES_SEARCH_DATA_ERROR";
const DELETE_MATERIAL_CONTROL = "DELETE_MATERIAL_CONTROL";
const DELETE_MATERIAL_CONTROL_SUCCESS = "DELETE_MATERIAL_CONTROL_SUCCESS";
const DELETE_MATERIAL_CONTROL_ERROR = "DELETE_MATERIAL_CONTROL_ERROR";
const CREATE_MATERIAL_CONTROL = "CREATE_MATERIAL_CONTROL";
const CREATE_MATERIAL_CONTROL_SUCCESS = "CREATE_MATERIAL_CONTROL_SUCCESS";
const CREATE_MATERIAL_CONTROL_ERROR = "CREATE_MATERIAL_CONTROL_ERROR";
const UPDATE_MATERIAL_CONTROL = "UPDATE_MATERIAL_CONTROL";
const UPDATE_MATERIAL_CONTROL_SUCCESS = "UPDATE_MATERIAL_CONTROL_SUCCESS";
const UPDATE_MATERIAL_CONTROL_ERROR = "UPDATE_MATERIAL_CONTROL_ERROR";
const DELETE_PROJECT_DOC_ATTACH = "DELETE_PROJECT_DOC_ATTACH";
const DELETE_PROJECT_DOC_ATTACH_SUCCESS = "DELETE_PROJECT_DOC_ATTACH_SUCCESS";
const DELETE_PROJECT_DOC_ATTACH_ERROR = "DELETE_PROJECT_DOC_ATTACH_ERROR";
const UPDATE_PROJECT_ISADD_ISUPDATE = "UPDATE_PROJECT_ISADD_ISUPDATE";
const ADD_PROJECT_DOC_ATTACH = "ADD_PROJECT_DOC_ATTACH";
const FETCH_PROJECT_BATCH_UPDATE = "FETCH_PROJECT_BATCH_UPDATE";
const FETCH_PROJECT_BATCH_UPDATE_SUCCESS = "FETCH_PROJECT_BATCH_UPDATE_SUCCESS";
const FETCH_PROJECT_BATCH_UPDATE_ERROR = "FETCH_PROJECT_BATCH_UPDATE_ERROR";
const FETCH_MATERIAL_CONTROL_BY_ID = "FETCH_MATERIAL_CONTROL_BY_ID";
const FETCH_MATERIAL_CONTROL_BY_ID_SUCCESS = "FETCH_MATERIAL_CONTROL_BY_ID_SUCCESS";
const FETCH_MATERIAL_CONTROL_BY_ID_ERROR = "FETCH_MATERIAL_CONTROL_BY_ID_ERROR";
const MARK_ITEM_AS_RECEIVED = "MARK_ITEM_AS_RECEIVED";
const MARK_ITEM_AS_RECEIVED_SUCCESS = "MARK_ITEM_AS_RECEIVED_SUCCESS";
const MARK_ITEM_AS_RECEIVED_ERROR = "MARK_ITEM_AS_RECEIVED_ERROR";
const MARK_ITEM_AS_COMPLETED = "MARK_ITEM_AS_COMPLETED";
const MARK_ITEM_AS_COMPLETED_SUCCESS = "MARK_ITEM_AS_COMPLETED_SUCCESS";
const MARK_ITEM_AS_COMPLETED_ERROR = "MARK_ITEM_AS_COMPLETED_ERROR";
const MARK_ITEM_AS_RECEIVED_UPDATE = "MARK_ITEM_AS_RECEIVED_UPDATE";
const MARK_ITEM_AS_RECEIVED_UPDATE_SUCCESS = "MARK_ITEM_AS_RECEIVED_UPDATE_SUCCESS";
const MARK_ITEM_AS_RECEIVED_UPDATE_ERROR = "MARK_ITEM_AS_RECEIVED_UPDATE_ERROR";
const OPEN_MAIN_FORM = "OPEN_MAIN_FORM";
const RESET_OPEN_MAIN_FORM = "RESET_OPEN_MAIN_FORM";
const RESET_NEW_MATERIAL_CONTROL = "RESET_NEW_MATERIAL_CONTROL";

// Project completion data constants
const FETCH_PROJECT_COMPLETION_DATA = "FETCH_PROJECT_COMPLETION_DATA";
const FETCH_PROJECT_COMPLETION_DATA_SUCCESS = "FETCH_PROJECT_COMPLETION_DATA_SUCCESS";
const FETCH_PROJECT_COMPLETION_DATA_ERROR = "FETCH_PROJECT_COMPLETION_DATA_ERROR";

export {
  FETCH_MATERIAL_CONTROL,
  FETCH_MATERIAL_CONTROL_SUCCESS,
  FETCH_MATERIAL_CONTROL_ERROR,
  FETCH_PROJECT_ACTIVITIES,
  FETCH_PROJECT_ACTIVITIES_SUCCESS,
  FETCH_PROJECT_ACTIVITIES_ERROR,
  FETCH_PROJECT_ACTIVITIES_GRAPH_DATA,
  FETCH_PROJECT_ACTIVITIES_GRAPH_DATA_SUCCESS,
  FETCH_PROJECT_ACTIVITIES_GRAPH_DATA_ERROR,
  FETCH_PROJECT_ACTIVITIES_SEARCH_DATA,
  FETCH_PROJECT_ACTIVITIES_SEARCH_DATA_SUCCESS,
  FETCH_PROJECT_ACTIVITIES_SEARCH_DATA_ERROR,
  UPDATE_PROJECT_ACTIVITY,
  UPDATE_PROJECT_ACTIVITY_SUCCESS,
  UPDATE_PROJECT_ACTIVITY_ERROR,
  DELETE_MATERIAL_CONTROL,
  DELETE_MATERIAL_CONTROL_SUCCESS,
  DELETE_MATERIAL_CONTROL_ERROR,
  CREATE_MATERIAL_CONTROL,
  CREATE_MATERIAL_CONTROL_SUCCESS,
  CREATE_MATERIAL_CONTROL_ERROR,
  UPDATE_MATERIAL_CONTROL,
  UPDATE_MATERIAL_CONTROL_SUCCESS,
  UPDATE_MATERIAL_CONTROL_ERROR,
  DELETE_PROJECT_DOC_ATTACH,
  DELETE_PROJECT_DOC_ATTACH_SUCCESS,
  DELETE_PROJECT_DOC_ATTACH_ERROR,
  UPDATE_PROJECT_ISADD_ISUPDATE,
  ADD_PROJECT_DOC_ATTACH,
  FETCH_PROJECT_BATCH_UPDATE,
  FETCH_PROJECT_BATCH_UPDATE_SUCCESS,
  FETCH_PROJECT_BATCH_UPDATE_ERROR,
  FETCH_MATERIAL_CONTROL_BY_ID,
  FETCH_MATERIAL_CONTROL_BY_ID_SUCCESS,
  FETCH_MATERIAL_CONTROL_BY_ID_ERROR,
  MARK_ITEM_AS_RECEIVED,
  MARK_ITEM_AS_RECEIVED_SUCCESS,
  MARK_ITEM_AS_RECEIVED_ERROR,
  MARK_ITEM_AS_COMPLETED,
  MARK_ITEM_AS_COMPLETED_SUCCESS,
  MARK_ITEM_AS_COMPLETED_ERROR,
  MARK_ITEM_AS_RECEIVED_UPDATE,
  MARK_ITEM_AS_RECEIVED_UPDATE_SUCCESS,
  MARK_ITEM_AS_RECEIVED_UPDATE_ERROR,
  OPEN_MAIN_FORM,
  RESET_OPEN_MAIN_FORM,
  RESET_NEW_MATERIAL_CONTROL,
  // Project completion data exports
  FETCH_PROJECT_COMPLETION_DATA,
  FETCH_PROJECT_COMPLETION_DATA_SUCCESS,
  FETCH_PROJECT_COMPLETION_DATA_ERROR,
};
